// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes fadeInMixin {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fadeOutMixin {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.CardContentBar {
  transition: background-color 0.2s;
  position: relative;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--gray_light2);
  border-radius: 8px;
  gap: 8px;
  height: 56px;
}
.CardContentBar-thumbnail {
  width: 34px;
  height: 34px;
}
.CardContentBar-thumbnail img {
  border-radius: 50%;
}
.CardContentBar.slide-sideways-enter {
  opacity: 0.01;
  max-width: 0;
}
.CardContentBar.slide-sideways-enter.slide-sideways-enter-active {
  max-width: 500px;
  opacity: 1;
  transition: all 200ms ease-in-out;
}
.CardContentBar.slide-sideways-leave {
  opacity: 1;
  max-width: 500px;
}
.CardContentBar.slide-sideways-leave.slide-sideways-leave-active {
  max-width: 0;
  opacity: 0.01;
  transition: all 200ms ease-in-out;
}
.CardContentBar-bullet {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
.CardContentBar-title {
  display: flex;
  position: relative;
  flex-direction: column;
}
.CardContentBar-title span {
  width: 160px;
  display: -webkit-box;
  line-clamp: 1;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
}
.CardContentBar-title-provider {
  font-size: 12px;
  color: var(--gray_dark1);
}
.CardContentBar-removeIcon {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 20px;
  height: 20px;
}
.CardContentBar-removeIcon svg {
  fill: var(--gray_light1);
}
.CardContentBar-removeIcon:hover svg {
  fill: var(--gray);
}`, "",{"version":3,"sources":["webpack://./src/mixins.scss","webpack://./src/components/SelectedItemsBar/components/CardContentBar/index.scss"],"names":[],"mappings":"AAwCA;EACE;IACE,UAAA;ECvCF;EDyCA;IACE,UAAA;ECvCF;AACF;AD0CA;EACE;IACE,UAAA;ECxCF;ED0CA;IACE,UAAA;ECxCF;AACF;AAbA;EACE,iCAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oCAAA;EACA,kBAAA;EACA,QAAA;EACA,YAAA;AAeF;AAbE;EACE,WAAA;EACA,YAAA;AAeJ;AAbI;EACE,kBAAA;AAeN;AAXE;EACE,aAAA;EACA,YAAA;AAaJ;AAXI;EACE,gBAAA;EACA,UAAA;EACA,iCAAA;AAaN;AATE;EACE,UAAA;EACA,gBAAA;AAWJ;AATI;EACE,YAAA;EACA,aAAA;EACA,iCAAA;AAWN;AAPE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AASJ;AANE;EACE,aAAA;EACA,kBAAA;EACA,sBAAA;AAQJ;AANI;EACE,YAAA;EDxDJ,oBAAA;EACA,aCwDwB;EDvDxB,qBCuDwB;EDtDxB,4BAAA;EACA,gBAAA;EACA,sBANoC;ACuEtC;AAVI;EACE,eAAA;EACA,wBAAA;AAYN;AARE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AAUJ;AARI;EACE,wBAAA;AAUN;AANM;EACE,iBAAA;AAQR","sourcesContent":["@mixin line-clamp($lines, $wordBreak: break-word) {\n  display: -webkit-box;\n  line-clamp: $lines;\n  -webkit-line-clamp: $lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  word-break: $wordBreak;\n}\n\n@mixin scrollbar(\n  $color: var(--color_neutral_200),\n  $colorHover: var(--color_neutral_400),\n  $colorActive: var(--color_neutral_500)\n) {\n  &::-webkit-scrollbar {\n    width: 7px;\n    height: 7px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: $color;\n    height: 80px;\n    border-radius: 50px;\n  }\n\n  &:hover {\n    &::-webkit-scrollbar-thumb {\n      background: $colorHover;\n    }\n  }\n\n  &::-webkit-scrollbar-thumb:active {\n    background: $colorActive;\n  }\n}\n\n@keyframes fadeInMixin {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeOutMixin {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n@mixin fadeIn($timing, $length, $delay, $fill) {\n  animation: fadeInMixin $timing $length $delay;\n  animation-fill-mode: $fill;\n}\n\n@mixin fadeOut($timing, $length, $delay, $fill) {\n  animation: fadeOutMixin $timing $length $delay;\n  animation-fill-mode: $fill;\n}\n\n@mixin noise {\n  position: relative;\n  &::after {\n    content: '';\n    position: absolute;\n    inset: 0;\n    z-index: -1;\n    background-image: url('./assets/images/png/noise.png');\n    background-position: 0% 0%;\n    background-size: 36.23046875px 36.23046875px;\n    background-repeat: repeat;\n    border-radius: 12px;\n    opacity: 0.3;\n  }\n}\n\n@mixin scoped-excluded($selector, $exclude-class) {\n  :is(#{$selector}):not(:where(#{$exclude-class} *)) {\n    @content;\n  }\n}\n","@import 'src/mixins';\n\n.CardContentBar {\n  transition: background-color 0.2s;\n  position: relative;\n  padding: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid var(--gray_light2);\n  border-radius: 8px;\n  gap: 8px;\n  height: 56px;\n\n  &-thumbnail {\n    width: 34px;\n    height: 34px;\n\n    img {\n      border-radius: 50%;\n    }\n  }\n\n  &.slide-sideways-enter {\n    opacity: 0.01;\n    max-width: 0;\n\n    &.slide-sideways-enter-active {\n      max-width: 500px;\n      opacity: 1;\n      transition: all 200ms ease-in-out;\n    }\n  }\n\n  &.slide-sideways-leave {\n    opacity: 1;\n    max-width: 500px;\n\n    &.slide-sideways-leave-active {\n      max-width: 0;\n      opacity: 0.01;\n      transition: all 200ms ease-in-out;\n    }\n  }\n\n  &-bullet {\n    width: 12px;\n    height: 12px;\n    border-radius: 50%;\n  }\n\n  &-title {\n    display: flex;\n    position: relative;\n    flex-direction: column;\n\n    span {\n      width: 160px;\n      @include line-clamp(1);\n    }\n\n    &-provider {\n      font-size: 12px;\n      color: var(--gray_dark1);\n    }\n  }\n\n  &-removeIcon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    width: 20px;\n    height: 20px;\n\n    svg {\n      fill: var(--gray_light1);\n    }\n\n    &:hover {\n      svg {\n        fill: var(--gray);\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
